$(function () {
    "use strict";

    $(document).on('ready', function () {

        var $addToFavs = $('.js-add-to-favourites');

        $addToFavs.each(function () {
            var $addToFavs = $(this);
            var options    = $addToFavs.data().addToFavourites;
            var isActive   = $addToFavs.hasClass(options.activeClass);

            var toggleHover = function () {

                if (isActive) {
                    $addToFavs.on('mouseenter.AddToFavourites', function () {
                        $(this).text(options.activeTextHover);
                    });
                    $addToFavs.on('mouseleave.AddToFavourites', function () {
                        $(this).text(options.activeText);
                    })
                }
                else {
                    $addToFavs.off('mouseenter.AddToFavourites');
                    $addToFavs.off('mouseleave.AddToFavourites');
                }
            };

            var toggleState = function () {
                $addToFavs
                .text(isActive ? options.inactiveText : options.activeText)
                .toggleClass(options.activeClass, !isActive);

                if (Boolean(options.addTrackingEventLabel) && Boolean(options.removeTrackingEventLabel)) {
                    if ('undefined' !== typeof window.Tracker) {
                        window.Tracker.pushEvent(
                            {
                                category: 'Favourites',
                                action: isActive ? 'Remove from favourites' : 'Add to favourites',
                                label: isActive ? (options.removeTrackingEventLabel || '') : (options.addTrackingEventLabel || '')
                            }
                        );
                    }
                }

                isActive = !isActive;
                toggleHover();
            };

            toggleHover();

            $addToFavs.on('click.AddToFavourites', function(event) {
                event.preventDefault();

                $.post(isActive ? options.removeUrl : options.addUrl)
                .fail(function (data) {
                    var errorMessage = 'Что-то пошло не так, попробуйте позднее';

                    if (_(JSON.parse(data.responseText)).isObject() && Boolean(JSON.parse(data.responseText).error)) {
                        errorMessage = JSON.parse(data.responseText).error;
                    }

                    Toasts.pushToast(errorMessage, 'fail');
                    toggleState();
                })
                .done(function () {
                    if (isActive) {
                        Toasts.pushToast('Фирма добавлена в команду', 'success', options.toastUrl, 3000);
                    }
                });

                toggleState();
                $addToFavs.blur();
            });
        });
    });
});